import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import classes from './index.module.scss';
import CountUp from 'react-countup';

const EntityCounts = ({ federalContractsTotalCount, businessTotalCount })=> {
  return (
    <section className={classes.Entity_Counts}>
      <Container>
        <Row>
          <Col lg={{ span: 5, offset: 1 }} md={6}>
            <div className={classes.Entity_Counts_Column}>
              <b className={classes.Entity_Counts_Count}>
                <CountUp 
                  start={0}
                  end={businessTotalCount} 
                  separator=","
                  duration={2}
                />
              </b>
              <h2 className={classes.Entity_Counts_Title}>
                Registered Businesses
              </h2>
            </div>
          </Col>
          <Col lg={{ span: 5 }} md={6}>
            <div className={classes.Entity_Counts_Column}>
            <b className={classes.Entity_Counts_Count}>
              <CountUp 
                start={0}
                end={federalContractsTotalCount} 
                separator=","
                duration={2}
              />
            </b>
            <h2 className={classes.Entity_Counts_Title}>
              Contract Opportunities
            </h2>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default EntityCounts;